import { AxiosResponse } from 'axios';
import type { AxiosInstance } from 'axios';
import { inject } from '@aesop-fables/containr';
import { ApiServices } from '../ApiServices';
import {
  PricebookBundle,
  AvailablePricebooks,
  PricebookBundleWithUsage,
} from '../../models/PricebookData';

export class PricebookApi {
  constructor(@inject(ApiServices.Axios) private axios: AxiosInstance) {}

  getAvailableOrgOptions(): Promise<AxiosResponse<PricebookBundle[]>> {
    return this.axios.get('organization-pricebook-options/available');
  }

  getAvailableOrgOptionsV2(): Promise<AxiosResponse<AvailablePricebooks>> {
    return this.axios.get('organization-pricebook-options/available/v2');
  }

  saveOrgOption(pricebookId: number): Promise<AxiosResponse<OrgPricebookOption>> {
    return this.axios.post(`organization-pricebook-options?pricebookId=${pricebookId}`);
  }

  saveOrgOptions(pricebookIds: number[]): Promise<AxiosResponse<OrgPricebookOption[]>> {
    return this.axios.post('organization-pricebook-options/all', null, {
      params: { pricebookIds: pricebookIds },
    });
  }

  deleteOrgOptions(): Promise<AxiosResponse<void>> {
    return this.axios.delete('organization-pricebook-options');
  }

  getOrgSelections(): Promise<AxiosResponse<SelectionData[]>> {
    return this.axios.get('organization-pricebook-selections');
  }

  selectOrgPricebook(id: number): Promise<AxiosResponse<SelectionData>> {
    return this.axios.post(`organization-pricebook-selections?pricebookId=${id}`);
  }

  getAvailableTeamOptions(): Promise<AxiosResponse<AvailablePricebooks>> {
    return this.axios.get('team-pricebook-options/available');
  }

  getAvailableTeamOptionsWithUsage(): Promise<AxiosResponse<PricebookBundleWithUsage[]>> {
    return this.axios.get('team-pricebook-options/available/with-usage');
  }

  getTeamOptions(): Promise<AxiosResponse<TeamPricebookOption[]>> {
    return this.axios.get('team-pricebook-options');
  }

  saveTeamOptions(pricebookIds: number[]): Promise<AxiosResponse<TeamPricebookOption[]>> {
    return this.axios.post('team-pricebook-options/all', null, {
      params: { pricebookIds: pricebookIds },
    });
  }

  deleteTeamOptions(): Promise<AxiosResponse<void>> {
    return this.axios.delete('team-pricebook-options');
  }

  getAvailableGroupOptions(): Promise<AxiosResponse<AvailablePricebooks>> {
    return this.axios.get('group-pricebook-options/available');
  }

  getAllPricebookBundles(): Promise<AxiosResponse<PricebookBundle[]>> {
    return this.axios.get('pricebook/pricebook-bundle');
  }
}

export interface OrgPricebookOption {
  id: number;
  organizationId: number;
  pricebookId: number;
}

export interface TeamPricebookOption {
  id: number;
  teamId: number;
  pricebookId: number;
}

export interface SelectionData {
  id: number;
  organizationId: number;
  pricebookId: number;
}
